import styled from "styled-components";

export const PortfolioContainer = styled.div`
  background: #f9f9f9;
  align-items: center;
  justify-content: center;
  padding-top: 90px;
  /* display:flex;
    flex-direction:column;
    justify-content: center;
    align-items:center;
    background:#f9f9f9; */
`;

export const SubTitle = styled.p`
  margin-bottom: 35px;
  font-size: 1.5rem;
  max-width: 1500px;
  text-align: center;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const PortfolioWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  grid-gap: 16px;
  padding: 0 50px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const PortfolioCard = styled.div`
  background: #fff;
  padding: 40px 20px;
  -webkit-box-shadow: 0px 42px 29px -31px rgb(0 0 0 / 5%);
  -moz-box-shadow: 0px 42px 29px -31px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 42px 29px -31px rgb(0 0 0 / 5%);
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  border-radius: 4px;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const PortfolioIcon = styled.img`
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  background: #fff;
  -webkit-box-shadow: 0px 42px 29px -31px rgb(0 0 0 / 5%);
  -moz-box-shadow: 0px 42px 29px -31px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 42px 29px -31px rgb(0 0 0 / 5%);
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  border-radius: 4px;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    height: 100%;
  }
`;

export const PortfolioH1 = styled.h1`
  color: #84ba3f;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  text-transform: uppercase;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const PortfolioH2 = styled.h2`
  font-size: 1rem;
  margin-bottom: 10px;
`;

export const PortfolioP = styled.p`
  font-size: 1rem;
  text-align: left;

  @media screen and (max-width: 768px) {
    text-align: left;
  }

  @media screen and (max-width: 480px) {
    text-align: left;
  }
`;
